import React from 'react';
import { Content } from '@radix-ui/react-dialog';
import { Dialog, DialogPortal, DialogOverlay, DialogTitle, DialogDescription } from '../ui/dialog';

export const AccountDialog = ({ id, title, description, onClose, forced, children }) => (
  <Dialog open onOpenChange={open => { if (!open && !forced) onClose(); }}>
    <DialogPortal>
      <DialogOverlay className="z-[100000]" data-testid={`${id}-overlay`} />
      <Content data-testid={id}
        onEscapeKeyDown={e => { if (forced) e.preventDefault(); }}
        onInteractOutside={e => { if (forced) e.preventDefault(); }}
        className="fixed left-1/2 top-1/2 z-[100001] w-[calc(100%_-_2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-lg border p-5 sm:p-7 shadow-2xl max-h-[90dvh] overflow-y-auto"
        style={{ background: 'var(--bg-card, #171717)', color: 'var(--text-primary, #eee)', borderColor: 'var(--border-light, #333)' }}>
        <DialogTitle data-testid={`${id}-title`} className="text-base md:text-lg">{title}</DialogTitle>
        <DialogDescription data-testid={`${id}-description`} className="mt-2 mb-6 text-sm">{description}</DialogDescription>
        {children}
      </Content>
    </DialogPortal>
  </Dialog>
);

export const accountError = error => {
  const body = error?.response?.data;
  return body?.message || body?.detail?.message || (typeof body?.detail === 'string' ? body.detail : 'Хүсэлт амжилтгүй. Дахин оролдоно уу');
};